import Vue from 'vue'
import Router from 'vue-router'
import cookie from '../utils/cookie.js'
import api from '@/common/api.js'

const login = resolve => require(['@/pages/login.vue'], resolve)
const blank = resolve => require(['@/pages/blank.vue'], resolve)
const home = resolve => require(['@/pages/home.vue'], resolve)
// 登录默认页面
const welcome = resolve => require(['@/pages/welcome.vue'], resolve)
// 工作台
const portanIndex = resolve => require(['@/pages/portal/index.vue'], resolve)
const banner = resolve => require(['@/pages/banner/index.vue'], resolve)
/** 系统管理 start */
/** 用户管理 start */
const system = resolve => require(['@/pages/systemManage/index.vue'], resolve)
const employee = resolve => require(['@/pages/systemManage/employee/employee.vue'], resolve)
const employeeAdd = resolve => require(['@/pages/systemManage/employee/employeeAdd.vue'], resolve)
const employeeEdit = resolve => require(['@/pages/systemManage/employee/employeeEdit.vue'], resolve)
// 版本控制
const versionsIndex = resolve => require(['@/pages/systemManage/versions/index.vue'], resolve)
// ---------消息中心
const mesCore = resolve => require(['@/pages/systemManage/newInfo/index.vue'], resolve)
const newsDetails = resolve => require(['@/pages/systemManage/newInfo/details.vue'], resolve)
// 消息模板
const mesPattern = resolve => require(['@/pages/systemManage/newInfo/pattern/index.vue'], resolve)
const templateDetails = resolve => require(['@/pages/systemManage/newInfo/pattern/details.vue'], resolve)
// 消息规则
const mesRule = resolve => require(['@/pages/systemManage/newInfo/infoRule/index.vue'], resolve)
const infoRuleList = resolve => require(['@/pages/systemManage/newInfo/infoRule/infoList.vue'], resolve)
const addEditInfo = resolve => require(['@/pages/systemManage/newInfo/infoRule/infoDetails.vue'], resolve)
// 发送信息
const sendIndex = resolve => require(['@/pages/systemManage/newInfo/sendInfo/index.vue'], resolve)
const sendMessage = resolve => require(['@/pages/systemManage/newInfo/sendInfo/sendMessage.vue'], resolve)
const messageList = resolve => require(['@/pages/systemManage/newInfo/sendInfo/messageList.vue'], resolve)

// ---------个人中心
const personal = resolve => require(['@/pages/myCenter/index.vue'], resolve)
const personalMenu = resolve => require(['@/pages/myCenter/memu.vue'], resolve)
/** 用户管理 end */
/** 调度任务 start */
const jobManager = resolve => require(['@/pages/systemManage/JobManager.vue'], resolve)
/** 调度任务 end */
/**
 * 配置管理
 */
const configInfoManager = resolve => require(['@/pages/systemManage/configInfoManager.vue'], resolve)
/**
 *
 * 缓存管理
 */
const cacheManager = resolve => require(['@/pages/systemManage/cacheManager.vue'], resolve)

/** 角色权限管理 start */
const roleManager = resolve => require(['@/pages/systemManage/role/roleManager.vue'], resolve)
const roleAdd = resolve => require(['@/pages/systemManage/role/roleAdd.vue'], resolve)
const roleEdit = resolve => require(['@/pages/systemManage/role/roleEdit.vue'], resolve)

const menuManager = resolve => require(['@/pages/systemManage/menuManager.vue'], resolve)
const buttonManager = resolve => require(['@/pages/systemManage/buttonManager.vue'], resolve)
/** 角色权限管理 end */
/** 系统管理 end */

/** 黑名单管理 start */
const blackListManage = resolve => require(['@/pages/blackListManage/index.vue'], resolve)
/** 黑名单 start */
const blackList = resolve => require(['@/pages/blackListManage/blackList.vue'], resolve)
/** 黑名单 end */
/** 黑名单管理 end */

/** 客商管理 start */
const merchantManage = resolve => require(['@/pages/merchantManage/index.vue'], resolve)

/** 企业管理 start */
const companyManage = resolve => require(['@/pages/merchantManage/companyManage/index.vue'], resolve)
const companyDetails = resolve => require(['@/pages/merchantManage/companyManage/companyDetails.vue'], resolve)
const dataChangeDetails = resolve => require(['@/pages/merchantManage/companyManage/dataChangeDetails.vue'], resolve)
const certificationDetails = resolve => require(['@/pages/merchantManage/companyManage/certificationDetails.vue'], resolve)
/** 企业管理 end */
// 企业账户管理
const corAccount = resolve => require(['@/pages/merchantManage/accountManage/index.vue'], resolve)
/** 司机管理 start */
const driverManage = resolve => require(['@/pages/merchantManage/driverManage/driverManage.vue'], resolve)
const driverDetails = resolve => require(['@/pages/merchantManage/driverManage/details.vue'], resolve)
const auditDriverdetails = resolve => require(['@/pages/merchantManage/driverManage/auditDriverdetails.vue'], resolve)
const auditSupercargoDetails = resolve => require(['@/pages/merchantManage/driverManage/auditSupercargoDetails.vue'], resolve)
const driverAuditHistoryDetails = resolve => require(['@/pages/merchantManage/driverManage/driverAuditHistoryDetails.vue'], resolve)

/** 司机管理 end */
// -------车辆管理
const carManage = resolve => require(['@/pages/merchantManage/carManage/index.vue'], resolve)
const vehicleDetails = resolve => require(['@/pages/merchantManage/carManage/carManageDetails.vue'], resolve)
const sysCarDetails = resolve => require(['@/pages/merchantManage/carManage/sysCarDetails.vue'], resolve)
const carCacheDetails = resolve => require(['@/pages/merchantManage/carManage/carCacheDetails.vue'], resolve)
// -------挂车管理
const trailerManage = resolve => require(['@/pages/merchantManage/trailerManage/trailerManage.vue'], resolve)
const trailerDetails = resolve => require(['@/pages/merchantManage/trailerManage/details.vue'], resolve)
const trailerDetail = resolve => require(['@/pages/merchantManage/trailerManage/trailerManageDetails.vue'], resolve)
const trailerCacheDetails = resolve => require(['@/pages/merchantManage/trailerManage/trailerCacheDetails.vue'], resolve)
// -------罐检报告管理
const tankInspectionManage = resolve => require(['@/pages/merchantManage/tankInspectionManage/index.vue'], resolve)
const tankInspectionDetails = resolve => require(['@/pages/merchantManage/tankInspectionManage/tankInspectionDetails.vue'], resolve)
const tankCacheDetails = resolve => require(['@/pages/merchantManage/tankInspectionManage/tankCacheDetails.vue'], resolve)
/** 客商管理 end */
// -------车源管理
const carSourceIndex = resolve => require(['@/pages/carSource/index.vue'], resolve)
const carDetails = resolve => require(['@/pages/carSource/details.vue'], resolve)
const carSource = resolve => require(['@/pages/carSource/carSource.vue'], resolve)
// 电子运单缴费管理
const waybillpayMgt = resolve => require(['@/pages/waybillpayMgt/index.vue'], resolve)
// -------结算管理
const settleIndex = resolve => require(['@/pages/funds/index.vue'], resolve)
const settleList = resolve => require(['@/pages/funds/settleManage/settleList.vue'], resolve)
const recall = resolve => require(['@/pages/funds/settleManage/details/recall.vue'], resolve)

/* 运输管理 */
const transportManage = resolve => require(['@/pages/transportManage/index.vue'], resolve)
/* 运单管理 */
const wayBillManage = resolve => require(['@/pages/transportManage/wayBillManage/wayBillManage.vue'], resolve)
const wayBillDetails = resolve => require(['@/pages/transportManage/wayBillManage/wayBillDetails.vue'], resolve)
/* 运输任务管理 */
const transportTask = resolve => require(['@/pages/transportManage/transportTask/transportTask.vue'], resolve)
const taskDetails = resolve => require(['@/pages/transportManage/transportTask/taskDetails.vue'], resolve)
const insureList = resolve => require(['@/pages/transportManage/insure/insureList.vue'], resolve)
const insureDetail = resolve => require(['@/pages/transportManage/insure/insureDetail.vue'], resolve)

/* 保证金管理 */
const depositManage = resolve => require(['@/pages/depositManage/index.vue'], resolve)
const allDepositManage = resolve => require(['@/pages/depositManage/allDepositManage.vue'], resolve)

/* 大单招标管理 */
const bidsManage = resolve => require(['@/pages/bidsManage/index.vue'], resolve)
const allBidsManage = resolve => require(['@/pages/bidsManage/allBidsManage.vue'], resolve)
const bidsDetails = resolve => require(['@/pages/bidsManage/bidsDetails.vue'], resolve)

/* 货源管理 */
const sourceManage = resolve => require(['@/pages/sourceManage/index.vue'], resolve)
const allSourceManage = resolve => require(['@/pages/sourceManage/allSourceManage.vue'], resolve)
const sourceDetails = resolve => require(['@/pages/sourceManage/sourceDetails.vue'], resolve)

/** 学习中心 */
const study = resolve => require(['@/pages/study/index.vue'], resolve)
const myStudy = resolve => require(['@/pages/study/myStudy.vue'], resolve)
const studyDetails = resolve => require(['@/pages/study/details/index.vue'], resolve)

/* 意见反馈 */
const feedback = resolve => require(['@/pages/feedback/index.vue'], resolve)
const allFeedback = resolve => require(['@/pages/feedback/allFeedback.vue'], resolve)

/* 内容管理 start */
const contentManage = resolve => require(['@/pages/contentManage/index.vue'], resolve)
/* 资讯管理 */
const newsManage = resolve => require(['@/pages/contentManage/newsManage/newsManage.vue'], resolve)
const infosDetails = resolve => require(['@/pages/contentManage/newsManage/infosDetails.vue'], resolve)

const announcementManage = resolve => require(['@/pages/contentManage/announcementManage/announcementManage.vue'], resolve)
const announceDetails = resolve => require(['@/pages/contentManage/announcementManage/announceDetails.vue'], resolve)
/* 广告管理 */
const adManage = resolve => require(['@/pages/contentManage/adManage/adManage.vue'], resolve)
/* 知名企业 */
const wellknownCorp = resolve => require(['@/pages/contentManage/wellknownCorp/wellknownCorp.vue'], resolve)
/* 内容管理 end */
// 洗罐站
const tankManage = resolve => require(['@/pages/washTank/index.vue'], resolve)
const tankList = resolve => require(['@/pages/washTank/tankList.vue'], resolve)

/* 公司管理 */
const corporationManage = resolve => require(['@/pages/corporationManage/index.vue'], resolve)
const allCorporationManage = resolve => require(['@/pages/corporationManage/allCorporationManage.vue'], resolve)

// 防疫管理
const epidemicPrevention = resolve => require(['@/pages/safeLearningManage/epidemicPrevention.vue'], resolve)
const epidemicReport = resolve => require(['@/pages/safeLearningManage/epidemicReport.vue'], resolve)
const epidemicReportStatistics = resolve => require(['@/pages/safeLearningManage/epidemicReportStatistics.vue'], resolve)
const epidemicCarList = resolve => require(['@/pages/safeLearningManage/epidemicCarList.vue'], resolve)
const washCarList = resolve => require(['@/pages/safeLearningManage/washCarList.vue'], resolve)
const inspectList = resolve => require(['@/pages/safeLearningManage/inspectList.vue'], resolve)

/* 车辆安全检查管理 */
const checkManage = resolve => require(['@/pages/carSecurityCheckManage/index.vue'], resolve)
const checkList = resolve => require(['@/pages/carSecurityCheckManage/checkList.vue'], resolve)

/* 下载中心管理 */
const downloadCenterManage = resolve => require(['@/pages/downloadCenterManage/index.vue'], resolve)
const downloadCenter = resolve => require(['@/pages/downloadCenterManage/downloadCenter.vue'], resolve)

/* App管理 */
const AppManage = resolve => require(['@/pages/AppManage/index.vue'], resolve)
const allAppManage = resolve => require(['@/pages/AppManage/allAppManage.vue'], resolve)
const appVersion = resolve => require(['@/pages/AppManage/appVersion.vue'], resolve)

// 提货协同
const nonstandard = resolve => require(['@/pages/nonstandard/index.vue'], resolve)
const entrustDetail = resolve => require(['@/pages/nonstandard/entrustDetail.vue'], resolve)
const planDetail = resolve => require(['@/pages/nonstandard/planDetail.vue'], resolve)
const taskDetail = resolve => require(['@/pages/nonstandard/taskDetail.vue'], resolve)

// 提货协同
const agreementManage = resolve => require(['@/pages/agreementManage/index.vue'], resolve)
const agreement = resolve => require(['@/pages/agreementManage/agreement.vue'], resolve)
const agreementDetails = resolve => require(['@/pages/agreementManage/agreementDetails.vue'], resolve)
// 宝武提卸
const dischargeIndex = resolve => require(['@/pages/dischargeManage/index.vue'], resolve)
const discharge = resolve => require(['@/pages/dischargeManage/dischargeManage.vue'], resolve)
const bringUp = resolve => require(['@/pages/dischargeManage/bringUpManage.vue'], resolve)
const holderManage = resolve => require(['@/pages/dischargeManage/holderManage/index.vue'], resolve)
// 宝武卸货 ---卸货车号申报
// const unloadDeclare = resolve => require(['@/pages/dischargeManage'])
/* 报表列表 start */
const reportList = resolve => require(['@/pages/reportList/index.vue'], resolve)
// 客商注册信息
const merchantRegistrationInfo = resolve => require(['@/pages/reportList/merchantRegistrationInfo/merchantRegistrationInfo.vue'], resolve)
// 客商月度统计信息
const merchantsMonthlyStatistics = resolve => require(['@/pages/reportList/merchantsMonthlyStatistics/merchantsMonthlyStatistics.vue'], resolve)
// 货源发布统计信息
const sourceReleaseStatistics = resolve => require(['@/pages/reportList/sourceReleaseStatistics/sourceReleaseStatistics.vue'], resolve)
// 货源成交统计信息
const sourceTransactionStatistics = resolve => require(['@/pages/reportList/sourceTransactionStatistics/sourceTransactionStatistics.vue'], resolve)
// 承运商接单量
const carrierOrderQuantity = resolve => require(['@/pages/reportList/carrierOrderQuantity/carrierOrderQuantity.vue'], resolve)
// 货主发布量月度统计
const shippersMonthlyStatistics = resolve => require(['@/pages/reportList/shippersMonthlyStatistics/shippersMonthlyStatistics.vue'], resolve)
// 承运商单量月统计
const carrierMonthlyOrderStatistics = resolve => require(['@/pages/reportList/carrierMonthlyOrderStatistics/carrierMonthlyOrderStatistics.vue'], resolve)
// 货主发布量月度排名
const shipperMonthlyRanking = resolve => require(['@/pages/reportList/shipperMonthlyRanking/shipperMonthlyRanking.vue'], resolve)
// 承运商接单量月度排名
const carrierMonthlyranking = resolve => require(['@/pages/reportList/carrierMonthlyranking/carrierMonthlyranking.vue'], resolve)
// 货主发布量成交量统计明细
const shipperStatisticsDetails = resolve => require(['@/pages/reportList/shipperStatisticsDetails/shipperStatisticsDetails.vue'], resolve)
const shipperDetails = resolve => require(['@/pages/reportList/shipperStatisticsDetails/shipperDetailsList.vue'], resolve)
// 承运商接单量统计明细
const carrierStatisticsDetails = resolve => require(['@/pages/reportList/carrierStatisticsDetails/carrierStatisticsDetails.vue'], resolve)
const carrierDetailsList = resolve => require(['@/pages/reportList/carrierStatisticsDetails/carrierDetailsList.vue'], resolve)

/* 报表列表 end */
// 设备管理
const deviceManage = resolve => require(['@/pages/deviceManage/index.vue'], resolve)
// 监控中心
const monitoringCenter = resolve =>
  require(['@/pages/monitoringCenter/index.vue'], resolve)
const monitor = resolve =>
  require(['@/pages/monitoringCenter/monitor/monitor.vue'], resolve)
const track = resolve =>
  require(['@/pages/monitoringCenter/track/track.vue'], resolve)
const logistics = resolve => require(['@/pages/monitoringCenter/logistics/logistics.vue'], resolve)
const factoryMonitor = resolve =>
  require(['@/pages/monitoringCenter/factoryMonitor/factoryMonitor.vue'], resolve)
const distributionMap = resolve =>
  require(['@/pages/monitoringCenter/distributionMap/distributionMap.vue'], resolve)
const dangerVehicleTransportChartSmall = resolve =>
  require(['@/pages/monitoringCenter/dangerVehicleTransportChart/dangerVehicleTransportChart.vue'], resolve)
const interfaceLog = resolve =>
require(["@/pages/monitoringCenter/interfaceLog/list/index.vue"], resolve);
const interfaceExtsysLog = resolve =>
require(["@/pages/monitoringCenter/interfaceLog/extsys/index.vue"], resolve);
const carMonitorLog = resolve =>
require(["@/pages/monitoringCenter/interfaceLog/carMonitorLog/index.vue"], resolve);

// 报警设置管理
const alarmManage = resolve => require(['@/pages/alarmSetManage/index.vue'], resolve)
const allAlarmManage = resolve => require(['@/pages/alarmSetManage/allAlarmManage.vue'], resolve)
const areaAlarmAdd = resolve => require(['@/pages/alarmSetManage/alarmSetAddManage/areaAlarmAdd.vue'], resolve)
const lineAlarmAdd = resolve => require(['@/pages/alarmSetManage/alarmSetAddManage/lineAlarmAdd.vue'], resolve)
const logisticMapAdd = resolve => require(['@/pages/alarmSetManage/alarmSetAddManage/logisticMapTypeAdd.vue'], resolve)
const distancePriceAdd = resolve => require(['@/pages/alarmSetManage/alarmSetAddManage/distancePriceAdd.vue'], resolve)
const skuAdd = resolve => require(['@/pages/alarmSetManage/alarmSetAddManage/skuAdd.vue'], resolve)
const analysisSettingAdd = resolve => require(['@/pages/alarmSetManage/alarmSetAddManage/analysisSettingAdd.vue'], resolve)

const deviceConnectManage = resolve => require(['@/pages/809deviceConnect/index.vue'], resolve)
const deviceList = resolve => require(['@/pages/809deviceConnect/device/deviceList.vue'], resolve)
const deviceAdd = resolve => require(['@/pages/809deviceConnect/device/deviceAdd.vue'], resolve)
// const deviceDetails = resolve => require(['@/pages/809deviceConnect/device/deviceDetails.vue'], resolve)
const deviceEdit = resolve => require(['@/pages/809deviceConnect/device/deviceEdit.vue'], resolve)
const vehicleList = resolve => require(['@/pages/809deviceConnect/vehicle/vehicleList.vue'], resolve)

// 大屏看板相关
const dataCenter = resolve => require(['@/pages/dataCenter/index.vue'], resolve)
const transportDataCenter = resolve => require(['@/pages/dataCenter/transportDataCenter/transportDataCenter.vue'], resolve)
const tradingFloorResourceCenter = resolve => require(['@/pages/dataCenter/tradingFloorResourceCenter/tradingFloorResourceCenter.vue'], resolve)
const productFlowAndOut = resolve => require(['@/pages/dataCenter/productFlowAndOut/productFlowAndOut.vue'], resolve)
const expenseAreaDistribute = resolve => require(['@/pages/dataCenter/expenseAreaDistribute/expenseAreaDistribute.vue'], resolve)
const vehicleCheckContorlCenter = resolve => require(['@/pages/dataCenter/vehicleCheckContorlCenter/vehicleCheckContorlCenter.vue'], resolve)
const trackDiffLine = resolve =>
  require(['@/pages/dataCenter/trackDiffer/trackDiffLine.vue'], resolve)
const dangerVehicleTransportChart = resolve => require(['@/pages/dataCenter/dangerVehicleTransportChart/dangerVehicleTransportChart.vue'], resolve)

/* 公共基础数据 start */
const sysBaseData = resolve => require(['@/pages/sysBaseData/index.vue'], resolve)
//危货品名录
const goodsType = resolve => require(['@/pages/sysBaseData/goodsType.vue'], resolve)
/* 公共基础数据 end */

/* 萤石摄像头 start */
const ezvizCameraDeviceList = resolve => require(['@/pages/ezvizCamera/deviceList.vue'], resolve);
/* 萤石摄像头 end */

/* 物流成本测算 start */
const costEst = resolve => require(['@/pages/costEstimation/index.vue'], resolve)
const costEstimation = resolve => require(['@/pages/costEstimation/costEstimation.vue'], resolve);
const costEstimationModel = resolve => require(['@/pages/costEstimation/costEstimationModel.vue'], resolve);
// const costEstimationModel = resolve => require(['@/pages/costEstimation/tip/add-model.vue'], resolve);
const costEstimationResult = resolve => require(['@/pages/costEstimation/costEstimationResult.vue'], resolve);
const costEstimationResultDetail = resolve => require(['@/pages/costEstimation/costEstimationResultDetail.vue'], resolve);

/* 物流成本测算 end */
Vue.use(Router)

const routes = [{
  path: '/',
  redirect: 'login'
}, {
  path: '/login',
  component: login

}, {
  path: '/home',
  name: '首页',
  component: home,
  children: [
    {
      path: 'welcome',
      name: 'welcome',
      component: welcome
    },
    {
      path: '/',
      name: '工作台',
      component: portanIndex
    }, {
      path: 'banner',
      name: 'banner工作台',
      component: banner
    }, {
      path: 'personal',
      name: '个人中心',
      component: personal,
      children: [{
        path: '/',
        name: '个人中心',
        component: personalMenu
      }]
    },{
      path: 'costEst',
      name: '物流成本测算',
      component: costEst,
      children: [
        {
          path: 'costEstimation',
          name: '物流成本测算',
          component: costEstimation
        },
        {
          path: 'costEstimationResult',
          name: '物流成本测算结果',
          component: costEstimationResult
        },
        {
          path: 'costEstimationResultDetail',
          name: '物流成本测算结果',
          component: costEstimationResultDetail
        },
        {
          path: 'costEstimationModel',
          name: '物流成本测算模型',
          component: costEstimationModel
        }]
    }, {
      path: 'system',
      name: '系统管理',
      component: system,
      children: [{
        path: 'employee',
        name: '用户管理',
        component: employee
      }, {
        path: 'employeeAdd',
        name: '添加用户',
        component: employeeAdd
      }, {
        path: 'employeeEdit',
        name: '修改用户',
        component: employeeEdit
      }, {
        path: 'roleManager',
        name: '角色管理',
        component: roleManager
      }, {
        path: 'roleAdd',
        name: '添加角色',
        component: roleAdd
      }, {
        path: 'roleEdit',
        name: '修改角色',
        component: roleEdit
      }, {
        path: 'menuManager',
        name: '菜单管理',
        component: menuManager
      }, {
        path: 'buttonManager',
        name: '按钮管理',
        component: buttonManager
      }, {
        path: 'configInfoManager',
        name: '配置项管理',
        component: configInfoManager
      }, {
        path: 'versions',
        name: '版本控制',
        component: versionsIndex,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'jobManager',
        name: '调度任务',
        component: jobManager
      }, {
        path: 'cacheManager',
        name: '缓存管理',
        component: cacheManager
      }, {
        path: 'pattern',
        name: '消息模板',
        component: mesPattern
      }, {
        path: 'patternDetails',
        name: '模板详情',
        component: templateDetails
      }, {
        path: 'infoRule',
        name: '消息规则',
        component: mesRule,
        children: [{
          path: '/',
          component: infoRuleList,
          name: '消息规则'
        }, {
          path: 'details',
          name: '添加/修改规则',
          component: addEditInfo
        }]
      }, {
        path: 'mesCore',
        name: '消息中心',
        component: mesCore
      }, {
        path: 'infos',
        name: '消息详情',
        component: newsDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'file',
        name: '发送消息',
        component: sendIndex,
        meta: {
          keepAlive: false
        },
        children: [
          {
            path: '/',
            name: '信息列表',
            component: messageList,
            meta: {
              keepAlive: false
            }
          }, {
            path: 'sendFile',
            name: '发送消息',
            component: sendMessage,
            meta: {
              keepAlive: false
            }
          }
        ]
      }]
    }, {
      path: 'blackListManage',
      name: '黑名单管理',
      component: blackListManage,
      children: [{
        path: 'blackList',
        name: '黑名单管理',
        component: blackList,
        meta: {
          keepAlive: true
        }
      }]
    }, {
      path: 'merchantManage',
      name: '客商管理',
      component: merchantManage,
      children: [{
        path: 'companyManage',
        name: '企业管理',
        component: companyManage,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'companyDetails',
        name: '企业详情',
        component: companyDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'dataChangeDetails',
        name: '资料审核详情',
        component: dataChangeDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'certificationDetails',
        name: '认证企业详情',
        component: certificationDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'account',
        name: '企业账户管理',
        component: corAccount,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'driverManage',
        name: '司机管理',
        component: driverManage,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'details',
        name: '司机详情',
        component: driverDetails,
        meta: {
          keepAlive: false
        }
      },{
        path: 'auditDriverdetails',
        name: '司机审核详情',
        component: auditDriverdetails,
        meta: {
          keepAlive: false
        }
      },{
        path: 'auditSupercargoDetails',
        name: '押运员审核详情',
        component: auditSupercargoDetails,
        meta: {
          keepAlive: false
        }
      },{
        path: 'driverAuditHistoryDetails',
        name: '驾押人员履历详情',
        component: driverAuditHistoryDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'carManage',
        name: '车辆管理',
        component: carManage,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'vehicleDetails',
        name: '车辆详情',
        component: vehicleDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'sysCarDetails',
        name: '系统车辆详情',
        component: sysCarDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'carCacheDetails',
        name: '车辆履历详情',
        component: carCacheDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'trailerManage',
        name: '挂车管理',
        component: trailerManage,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'trailerDetail',
        name: '挂车详情',
        component: trailerDetail,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'trailerDetails',
        name: '挂车详情',
        component: trailerDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'trailerCacheDetails',
        name: '挂车履历详情',
        component: trailerCacheDetails,
        meta: {
          keepAlive: false
        }
      },{
        path: 'tankInspectionManage',
        name: '罐检报告管理',
        component: tankInspectionManage,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'tankInspectionDetails',
        name: '罐检报告详情',
        component: tankInspectionDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'tankCacheDetails',
        name: '罐检履历详情',
        component: tankCacheDetails,
        meta: {
          keepAlive: false
        }
      },
      ]
    }, {
      path: 'settle',
      name: '结算管理',
      component: settleIndex,
      meta: {
        keepAlive: false
      },
      children: [
        {
          path: '/',
          name: '结算管理',
          component: settleList,
          meta: {
            keepAlive: false
          }
        }, {
          path: 'recall',
          name: '结算详情',
          component: recall,
          meta: {
            keepAlive: false
          }
        }
      ]
    }, {
      path: 'carSource',
      name: '车源管理',
      component: carSourceIndex,
      meta: {
        keepAlive: false
      },
      children: [{
        path: '/',
        name: '',
        component: carSource,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'details',
        name: '车源详情',
        component: carDetails,
        meta: {
          keepAlive: false
        }
      }]
    }, {
      path: 'waybillpayMgt',
      name: '电子运单缴费管理',
      component: waybillpayMgt
    },{
      path: 'deviceManage',
      name: '设备管理',
      component: deviceManage
    }, {
      path: 'alarmManage',
      name: '报警管理',
      meta: {
        keepAlive: false
      },
      component: alarmManage,
      children: [
        {
          path: 'allAlarmManage',
          name: '报警管理列表',
          component: allAlarmManage
        }, {
          path: 'areaAlarmAdd',
          name: '添加区域报警',
          component: areaAlarmAdd
        }, {
          path: 'lineAlarmAdd',
          name: '添加线路报警',
          component: lineAlarmAdd
        }, {
          path: 'logisticMapAdd',
          name: '添加物流地图类型',
          component: logisticMapAdd
        }, {
          path: 'distancePriceAdd',
          name: '添加运价设置',
          component: distancePriceAdd
        },
        {
          path: 'skuAdd',
          name: 'SKU领域设置',
          component: skuAdd
        },
        {
          path: 'analysisSettingAdd',
          name: '趟次识别参数设置',
          component: analysisSettingAdd
        }
      ]
    }, {
      path: 'deviceConnectManage',
      name: '809设备管理',
      meta: {
        keepAlive: false
      },
      component: deviceConnectManage,
      children: [
        {
          path: 'deviceList',
          name: '设备管理',
          component: deviceList
        }, {
          path: 'deviceAdd',
          name: '添加设备',
          component: deviceAdd
        }, {
          path: 'deviceEdit',
          name: '修改设备',
          component: deviceEdit
        }, {
          path: 'vehicleList',
          name: '车辆管理',
          component: vehicleList
        }
      ]
    }, {
      path: 'study',
      name: '我的学习',
      component: study,
      meta: {
        keepAlive: false
      },
      children: [
        {
          path: '/',
          component: myStudy
        }, {
          path: 'details',
          name: '题库详情',
          component: studyDetails
        }
      ]
    }, {
      path: 'depositManage',
      name: '保证金管理',
      component: depositManage,
      meta: {
        keepAlive: true
      },
      children: [{
        path: '/',
        component: allDepositManage
      }]
    }, {
      path: 'bidsManage',
      name: '大单招标管理',
      component: bidsManage,
      meta: {
        keepAlive: true
      },
      children: [{
        path: '/',
        component: allBidsManage
      }, {
        path: 'bidsDetails',
        component: bidsDetails,
        meta: {
          keepAlive: false
        }
      }]
    }, {
      path: 'sourceManage',
      name: '货源管理',
      component: sourceManage,
      meta: {
        keepAlive: true
      },
      children: [{
        path: '/',
        component: allSourceManage
      }, {
        path: 'sourceDetails',
        component: sourceDetails,
        meta: {
          keepAlive: false
        }
      }]
    }, {
      path: 'transportManage',
      name: '运输管理',
      component: transportManage,
      children: [{
        path: 'wayBillManage',
        name: '运单管理',
        component: wayBillManage,
        meta: {
          keepAlive: true
        }
      }, {
        path: 'wayBillDetails',
        name: '运单详情',
        component: wayBillDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'transportTask',
        name: '运输任务管理',
        component: transportTask,
        meta: {
          keepAlive: true
        }
      }, {
        path: 'taskDetails',
        name: '运输任务详情',
        component: taskDetails,
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'insureList',
        name: '保单列表',
        component: insureList,
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'insureDetail',
        name: '保单详情',
        component: insureDetail,
        meta: {
          keepAlive: false
        }
      }
      ]
    }, {
      path: 'feedback',
      name: '意见反馈',
      component: feedback,
      children: [{
        path: '/',
        component: allFeedback
      }],
      meta: {
        keepAlive: true
      }
    }, {
      path: 'contentManage',
      name: '内容管理',
      component: contentManage,
      children: [{
        path: 'newsManage',
        name: '资讯管理',
        component: newsManage,
        meta: {
          keepAlive: true
        }
      }, {
        path: 'infosDetails',
        name: '资讯详情',
        component: infosDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'adManage',
        name: '广告管理',
        component: adManage,
        meta: {
          keepAlive: true
        }
      }, {
        path: 'announcementManage',
        name: '公告管理',
        component: announcementManage,
        meta: {
          keepAlive: true
        }
      }, {
        path: 'announcementDetails',
        name: '公告详情',
        component: announceDetails,
        meta: {
          keepAlive: false
        }
      }, {
        path: 'wellknownCorp',
        name: '知名企业',
        component: wellknownCorp,
        meta: {
          keepAlive: true
        }
      }]
    }, {
      path: 'tank',
      name: '洗罐站管理',
      component: tankManage,
      meta: {
        keepAlive: false
      },
      children: [{
        path: '/',
        component: tankList,
        meta: {
          keepAlive: false
        }
      }]
    }, {
      path: 'corporationManage',
      name: '公司管理',
      component: corporationManage,
      children: [
        {
          path: '/',
          component: allCorporationManage
        }
      ],
      meta: {
        keepAlive: true
      }
    }, {
      path: 'epidemicPrevention',
      name: '防疫管理',
      component: epidemicPrevention,
      meta: {
        keepAlive: true
      }
    }, {
      path: 'epidemicReport',
      name: '防疫上报',
      component: epidemicReport,
      meta: {
        keepAlive: true
      }
    }, {
      path: 'epidemicReportStatistics',
      name: '碳业防疫报表',
      component: epidemicReportStatistics,
      meta: {
        keepAlive: true
      }
    }, {
      path: 'epidemicCarList',
      name: '防疫车辆管理',
      component: epidemicCarList,
      meta: {
        keepAlive: true
      }
    }, {
      path: 'washCarList',
      name: '防疫车辆管理',
      component: washCarList,
      meta: {
        keepAlive: true
      }
    }, {
      path: 'inspectList',
      name: '车容检查管理',
      component: inspectList,
      meta: {
        keepAlive: true
      }
    }, {
      path: 'carSecurityCheckManage',
      name: '车辆检查管理',
      component: checkManage,
      children: [
        {
          path: '/',
          component: checkList
        }
      ],
      meta: {
        keepAlive: true
      }
    }, {
      path: 'downloadCenterManage',
      name: '下载中心管理',
      component: downloadCenterManage,
      children: [
        {
          path: '/',
          component: downloadCenter,
          meta: {
            keepAlive: true
          }
        }
      ],
      meta: {
        keepAlive: true
      }
    }, {
      path: 'AppManage',
      name: 'App管理',
      component: AppManage,
      children: [
        {
          path: '/',
          component: allAppManage,
          meta: {
            keepAlive: true
          }
        }, {
          path: 'AppVersion',
          component: appVersion,
          meta: {
            keepAlive: false
          }
        }
      ],
      meta: {
        keepAlive: true
      }
    }, {
      path: 'nonstandard',
      name: '宝化提货协同',
      component: nonstandard,
      meta: {
        keepAlive: true
      }
    }, {
      path: 'toDischarge',
      name: '宝武提卸',
      component: dischargeIndex,
      children: [
        {
          path: 'bringUp',
          name: '提货管理',
          component: bringUp
        }, {
          path: 'unload',
          name: '卸货管理',
          component: discharge
        }, {
          path: 'holderManage',
          name: '持证车辆列表管理',
          component: holderManage
        }
      ]
    },
    {
      path: 'entrustDetail',
      name: '委托详情',
      component: entrustDetail,
      meta: {
        keepAlive: false
      }
    }, {
      path: 'planDetail',
      name: '计划详情',
      component: planDetail,
      meta: {
        keepAlive: false
      }
    }, {
      path: 'taskDetail',
      name: '任务详情',
      component: taskDetail,
      meta: {
        keepAlive: false
      }
    }, {
      path: 'agreementManage',
      name: '协议管理',
      component: agreementManage,
      children: [
        {
          path: '/',
          component: agreement,
          meta: {
            keepAlive: true
          }
        }, {
          path: 'agreementDetails',
          name: '协议详情',
          component: agreementDetails,
          meta: {
            keepAlive: false
          }
        }
      ],
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'reportList',
      name: '报表列表',
      component: reportList,
      children: [
        {
          path: 'merchantRegistrationInfo',
          name: '客商注册信息',
          component: merchantRegistrationInfo,
          meta: {
            keepalive: true
          }
        },
        {
          path: 'merchantsMonthlyStatistics',
          name: '客商月度统计信息',
          component: merchantsMonthlyStatistics,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'sourceReleaseStatistics',
          name: '货源发布统计信息',
          component: sourceReleaseStatistics,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'sourceTransactionStatistics',
          name: '货源成交统计信息',
          component: sourceTransactionStatistics,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'carrierOrderQuantity',
          name: '承运商接单量',
          component: carrierOrderQuantity,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'shippersMonthlyStatistics',
          name: '货主发布量月度统计',
          component: shippersMonthlyStatistics,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'carrierMonthlyOrderStatistics',
          name: '承运商单量月统计',
          component: carrierMonthlyOrderStatistics,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'shipperMonthlyRanking',
          name: '货主发布量月度排名',
          component: shipperMonthlyRanking,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'carrierMonthlyranking',
          name: '承运商接单量月度排名',
          component: carrierMonthlyranking,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'shipperStatisticsDetails',
          name: '货主发布量成交量统计明细',
          component: shipperStatisticsDetails,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'shipperDetails',
          name: '明细',
          component: shipperDetails,
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'carrierStatisticsDetails',
          name: '承运商接单量统计明细',
          component: carrierStatisticsDetails,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'carrierDetailsList',
          name: '明细',
          component: carrierDetailsList,
          meta: {
            keepAlive: false
          }
        }
      ]
    },
    {
      path: 'monitoringCenter',
      name: '监控中心',
      component: monitoringCenter,
      children: [
        {
          path: 'monitor',
          name: '全国监控',
          component: monitor,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'factoryMonitor',
          name: '厂区监控',
          component: factoryMonitor,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'track',
          name: '轨迹回放',
          component: track,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'logistics',
          name: '物流地图',
          component: logistics,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'distributionMap',
          name: '全国厂家分布图',
          component: distributionMap,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'dangerVehicleTransportChart',
          name: '危化车辆全国道路热力图',
          component: dangerVehicleTransportChartSmall,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "interfaceLog",
          name: "中交接口调用记录",
          component: interfaceLog,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "interfaceExtsysLog",
          name: "车辆位置被调用记录",
          component: interfaceExtsysLog,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "carMonitorLog",
          name: "车辆监控列表",
          component: carMonitorLog,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'ezvizFactoryMonitor',
          name: '工厂监控',
          component: ezvizCameraDeviceList,
          meta: {
            keepAlive: true
          }
        },
      ]
    },
    {
      path: 'sysBaseData',
      name: '公共基础数据',
      component: sysBaseData,
      meta: {
        keepAlive: false
      },
      children: [{
        path: 'goodsType',
        name: '危货品名录',
        component: goodsType,
        meta: {
          keepAlive: false
        }
      }]
    },
  ]
},
{
  path: '/dataCenter',
  name: '数据中心',
  component: dataCenter,
  children: [
    {
      path: 'transportDataCenter',
      name: '智运平台数据中心',
      component: transportDataCenter,
      meta: {
        menu: true
      }
    },
    {
      path: 'tradingFloorResourceCenter',
      name: '交易大厅资源中心',
      component: tradingFloorResourceCenter,
      meta: {
        menu: true
      }
    },
    {
      path: 'productFlowAndOut',
      name: '产品出货量及流向',
      component: productFlowAndOut,
      meta: {
        menu: true
      }
    },
    {
      path: 'expenseAreaDistribute',
      name: '消费区域分布图',
      component: expenseAreaDistribute,
      meta: {
        menu: true
      }
    },
    {
      path: 'vehicleCheckContorlCenter',
      name: '车辆检查监控中心',
      component: vehicleCheckContorlCenter,
      meta: {
        menu: true
      }
    },
    {
      path: 'trackDiffLine',
      name: '轨迹线对比',
      component: trackDiffLine,
      meta: {
        menu: true
      }
    },
    {
      path: 'dangerVehicleTransportChart',
      name: '危化车辆全国道路热力图',
      component: dangerVehicleTransportChart,
      meta: {
        menu: true
      }
    }
  ]
},
{
  path: '*',
  component: blank
} ]
const router = new Router({
  routes
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  console.log(to)
  if (to.meta.keepAlive) {
    if (cookie.getCookie(api.platformlogin.sessionId)) {
      if(localStorage.getItem('weakPassword') == '1' && to.path != '/home/personal') {
        next({
          path: '/home/personal',
          query: {
            redirect: to.fullPath
          }
        })
      } else {
        next()
      }
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    // 大屏要从新标签页打开
    if (to.meta.menu && from.path !== '/') {
      if(localStorage.getItem('weakPassword') == '1' && to.path != '/home/personal') {
        next({
          path: '/home/personal',
          query: {
            redirect: to.fullPath
          }
        })
      } else {
        let url = router.resolve({
          path: `${to.path}`
        })
        window.open(url.href)
        next(false)
      }

    } else {
      if(localStorage.getItem('weakPassword') == '1' && to.path != '/home/personal') {
        if (to.path === '/login') {
          next() // 放行登录页
          return
        }
        next({
          path: '/home/personal',
          query: {
            redirect: to.fullPath
          }
        })
      } else {
        next()
      }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js